const AppData = {
  BASE_URL: 'https://api.pasajebus.com/',
  // BASE_URL: 'https://busstage1.kupas.cl/',
  CARPOOL_URL: '',
  // AT_URL: 'https://at.kupos.cl/',
  AT_URL: 'https://at.kupos.cl/',
  // AT_URL: 'https://at.kupos.cl/',
  // AT_URL: 'http://3.81.28.102:4000/',
  // BASE_URL: 'https://www.portals.org.in/',
  // BASE_URL: 'https://api.pasajebus.com/',
  BASE_URL_V2: 'https://at.kupos.cl/api/v2/',
  BASE_URL_V3: 'https://at.kupos.cl/api/v3/',
  // BASE_URL_V3: 'https://at.kupos.cl/api/v3/',
  BIP_URL: 'https://stg2.bip.kupos.cl/',
  // BIP_URL: 'http://3.225.222.55:8000/',
  ONE_SIGNAL_APP_ID: '234fd2db-ea84-4b59-ab4b-28a3ea826474',
  SENDER_ID: '730867902568',
  MAP_API_KEY: 'AIzaSyAZwHr1fuhn2Jh5dsENAPuGJJT4iTJpdCM',
  FB_APP_ID: '409783556699660',
  // FB_APP_ID: '177184106959636',mjmmm,
  X_OP_APP_DOMAIN: window.location.host.replace('www.',''),
  X_OPSITE: true
};
export default AppData



// WEBPACK FOOTER //
// ./src/services/appData.js